<template>
    <div class="c-chat__message" :class="{'c-chat__message--other': message.is_van_sigv}">
        <div class="c-chat__message-info">
            <div class="c-chat__message-name">
                {{name}}
            </div>
            <div class="c-chat__message-relative-time">
                {{message.created_at | relativeTime}}
            </div>
        </div>
        <div class="c-chat__message-content" v-html="body"></div>
    </div>
</template>
<script>
import Utils from '@classes/Utils';

export default {
    props: {
        message: {
            required: true,
            type:Object
        }
    },
    filters: {
        relativeTime(value) {
            return Utils.relativeTime(new Date(value));
        }
    },
    computed: {
        body() {
            return this.message.tekst.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },
        name() {
            if (this.message.is_van_sigv) {
                return 'Planner';
            }
            else if ( this.message.berichtable.opdrachtnemer ) {
                return this.message.berichtable.opdrachtnemer.user.name;
            }
            else if ( this.message.berichtable.opdrachtgever ) {
                return this.message.berichtable.opdrachtgever.user.name;
            }

            return '-';
        }
    }
}
</script>
